import React from "react";
import { Link } from "react-router-dom";

export function LegalLayout({ title, intro, sections, testId }) {
  return (
    <div data-testid={testId} className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <span className="font-mono-spec text-xs uppercase tracking-widest text-brand-navy">Legal</span>
      <h1 className="mt-3 font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-brand-ink">{title}</h1>
      <p className="mt-3 text-sm text-muted-foreground">Last updated: June 2026</p>
      <p className="mt-6 text-muted-foreground leading-relaxed">{intro}</p>
      <div className="mt-10 space-y-10">
        {sections.map((s, i) => (
          <section key={s.h} data-testid={`${testId}-section-${i + 1}`}>
            <h2 className="font-display font-semibold text-lg text-brand-ink">{i + 1}. {s.h}</h2>
            <div className="mt-3 space-y-3 text-muted-foreground leading-relaxed text-sm sm:text-base">
              {s.p?.map((t) => <p key={t}>{t}</p>)}
              {s.list && (
                <ul className="list-disc pl-5 space-y-1.5">
                  {s.list.map((t) => <li key={t}>{t}</li>)}
                </ul>
              )}
            </div>
          </section>
        ))}
      </div>
      <div className="mt-14 pt-6 border-t text-sm text-muted-foreground flex flex-wrap gap-4">
        <Link to="/privacy" data-testid="legal-link-privacy" className="hover:text-brand-navy">Privacy Policy</Link>
        <Link to="/terms" data-testid="legal-link-terms" className="hover:text-brand-navy">Terms of Service</Link>
        <Link to="/cookies" data-testid="legal-link-cookies" className="hover:text-brand-navy">Cookie Policy</Link>
      </div>
    </div>
  );
}
